(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["golden-saldo-product"]) return;
  try {
    
if (!customElements.get('golden-saldo')) {
  customElements.define('golden-saldo', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const form = this.querySelector('form');
      const choices = form.querySelectorAll('input[type="radio"][name="id"]');
      form.removeAttribute('novalidate');
      const submitButton = form.querySelector('[type="submit"]');
      const errorMessage = form.querySelector('.golden-saldo__error');
      if (document.querySelector('cart-drawer')) submitButton.setAttribute('aria-haspopup', 'dialog');
      form.addEventListener('submit', async (event) => {
        for (const field of form.querySelectorAll('input[type="text"], input[type="tel"]')) field.value = field.value.trim();
        if (!form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const cart = document.querySelector('cart-drawer');
        if (!cart) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.submitting) return;
        this.submitting = true;
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
        errorMessage.hidden = true;
        try {
          await customElements.whenDefined('cart-drawer');
          const formData = new FormData(form);
          formData.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
          formData.set('sections_url', window.location.pathname);
          cart.setActiveElement(submitButton);
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || errorMessage.dataset.cartError);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: result });
          }
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } catch (error) {
          errorMessage.textContent = error.message || errorMessage.dataset.cartError;
          errorMessage.hidden = false;
        } finally {
          this.submitting = false;
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        }
      }, true);
      choices.forEach(choice => choice.addEventListener('change', () => {
        this.querySelectorAll('[data-saldo-image]').forEach(image => { image.hidden = image.dataset.saldoImage !== choice.value; });
        this.querySelectorAll('[data-saldo-price]').forEach(price => { price.hidden = price.dataset.saldoPrice !== choice.value; });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', choice.value);
        window.history.replaceState({}, '', url);
        const shareButton = this.querySelector('share-button');
        if (shareButton && typeof shareButton.updateUrl === 'function') {
          const shareUrl = new URL(shareButton.urlToShare);
          shareUrl.searchParams.set('variant', choice.value);
          shareButton.updateUrl(shareUrl.toString());
        }
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ngr-character-cake"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ngr-character-carousel')) {
  customElements.define('ngr-character-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.ngr-character__track');
      this.buttons = Array.from(this.querySelectorAll('[data-direction]'));
      this.update = () => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.buttons[0].disabled = this.track.scrollLeft <= 2;
        this.buttons[1].disabled = this.track.scrollLeft >= maximum - 2;
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const card = this.track.querySelector('.ngr-character__card');
        const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({left: Number(button.dataset.direction) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      this.track.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.track?.removeEventListener('scroll', this.update);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ngr-character-fan"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ngr-character-fan')){
 customElements.define('ngr-character-fan',class extends HTMLElement{
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
   this.cards=Array.from(this.querySelectorAll('.ngr-fan__card'));this.active=Math.min(2,this.cards.length-1);
   this.select=(i)=>{if(!this.cards.length)return;this.active=(i+this.cards.length)%this.cards.length;this.cards.forEach((c,n)=>{let d=(n-this.active+this.cards.length)%this.cards.length;if(d>this.cards.length/2)d-=this.cards.length;c.dataset.slot=Math.abs(d)<=2?String(d):'hidden';c.tabIndex=d===0?0:-1;});this.querySelectorAll('[data-select]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.select)===this.active)));};
   this.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>this.select(this.active+Number(b.dataset.direction)),opts));
   this.querySelectorAll('[data-select]').forEach(b=>b.addEventListener('click',()=>this.select(Number(b.dataset.select)),opts));
   this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.select(this.active+(e.key==='ArrowRight'?1:-1));}},opts);
   const stage=this.querySelector('.ngr-fan__stage');let start=null;
   stage.addEventListener('touchstart',e=>{start={x:e.touches[0].clientX,y:e.touches[0].clientY};},{...opts,passive:true});
   stage.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){this.select(this.active+(dx<0?1:-1));this.swiped=true;setTimeout(()=>{this.swiped=false;},400);}start=null;},{...opts,passive:true});
   stage.addEventListener('click',e=>{if(this.swiped){e.preventDefault();return;}const card=e.target.closest('.ngr-fan__card');if(card&&card.dataset.slot!=='0'){e.preventDefault();this.select(Number(card.dataset.index));}},opts);
   this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.ngr-fan__card');if(card)this.select(Number(card.dataset.index));},opts);
   this.select(this.active);
  }
  disconnectedCallback(){this.abort?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ngr-express-cards"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ngr-express-carousel'))customElements.define('ngr-express-carousel',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.rail=this.querySelector('.ngr-express__rail');this.prev=this.querySelector('.ngr-express__prev');this.next=this.querySelector('.ngr-express__next');
const update=()=>{const max=this.rail.scrollWidth-this.rail.clientWidth;this.prev.hidden=this.next.hidden=max<2;this.prev.disabled=this.rail.scrollLeft<2;this.next.disabled=this.rail.scrollLeft>=max-2};
const move=d=>{const card=this.rail.querySelector('.ngr-express__card');if(card)this.rail.scrollBy({left:d*(card.getBoundingClientRect().width+(parseFloat(getComputedStyle(this.rail).gap)||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};
this.prev.addEventListener('click',()=>move(-1),{signal});this.next.addEventListener('click',()=>move(1),{signal});this.rail.addEventListener('scroll',update,{signal,passive:true});
this.observer=new ResizeObserver(update);
this.observer.observe(this.rail);this.querySelectorAll('.ngr-express__content').forEach(el=>this.observer.observe(el));update()}
disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();this.abort=null}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ngr-promo-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPromoSliders(root){
    var scope=root||document;
    var sliders=scope.querySelectorAll?scope.querySelectorAll('[data-ngr-promo-slider]'):[];
    sliders.forEach(function(slider){
      if(slider.dataset.initialized==='true') return;
      slider.dataset.initialized='true';

      var track=slider.querySelector('[data-promo-track]');
      var slides=Array.prototype.slice.call(slider.querySelectorAll('[data-promo-slide]'));
      var dots=Array.prototype.slice.call(slider.querySelectorAll('[data-promo-dot]'));
      var index=0;
      var timer=null;
      var touchStartX=0;
      var touchEndX=0;
      var autoplay=slider.dataset.autoplay==='true';
      var speed=parseInt(slider.dataset.speed,10)||5000;
      var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if(!track||slides.length<2) return;

      function render(){
        track.style.transform='translate3d(' + (-index*100) + '%,0,0)';
        dots.forEach(function(dot,dotIndex){
          if(dotIndex===index) dot.setAttribute('aria-current','true');
          else dot.removeAttribute('aria-current');
        });
      }

      function goTo(newIndex){
        index=(newIndex+slides.length)%slides.length;
        render();
      }

      function stop(){
        if(timer){window.clearInterval(timer);timer=null;}
      }

      function start(){
        stop();
        if(autoplay&&!reduceMotion){
          timer=window.setInterval(function(){goTo(index+1);},speed);
        }
      }

      dots.forEach(function(dot){
        dot.addEventListener('click',function(){
          goTo(parseInt(dot.dataset.promoDot,10)||0);
          start();
        });
      });

      slider.addEventListener('mouseenter',stop);
      slider.addEventListener('mouseleave',start);
      slider.addEventListener('focusin',stop);
      slider.addEventListener('focusout',start);

      slider.addEventListener('touchstart',function(event){
        touchStartX=event.changedTouches[0].screenX;
      },{passive:true});

      slider.addEventListener('touchend',function(event){
        touchEndX=event.changedTouches[0].screenX;
        var distance=touchEndX-touchStartX;
        if(Math.abs(distance)>40){
          if(distance<0) goTo(index+1);
          else goTo(index-1);
          start();
        }
      },{passive:true});

      render();
      start();
    });
  }

  initPromoSliders(document);
  document.addEventListener('shopify:section:load',function(event){initPromoSliders(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-collection-tabs"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ngr-moments'))customElements.define('ngr-moments',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.tabs=[...this.querySelectorAll('[role=tab]')];this.panels=[...this.querySelectorAll('[role=tabpanel]')];this.tabs.forEach((t,i)=>{t.addEventListener('click',()=>this.select(i));t.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;if(e.key==='ArrowLeft')n=(i+this.tabs.length-1)%this.tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=this.tabs.length-1;if(n!==undefined){e.preventDefault();this.select(n);this.tabs[n].focus()}})});this.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[role=tabpanel]');const i=this.panels.indexOf(panel);if(i>=0)this.select(i)})}
select(i){this.tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(n===i));t.tabIndex=n===i?0:-1});this.panels.forEach((p,n)=>{p.hidden=n!==i})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-testimonial-9"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ngr-review-flow'))customElements.define('ngr-review-flow',class extends HTMLElement{
connectedCallback(){
if(this.controller)return;
this.controller=new AbortController();const signal=this.controller.signal;
this.row=this.querySelector('.ngr-review-flow__row');this.media=matchMedia('(prefers-reduced-motion: reduce)');
this.visible=false;this.hovered=false;this.touching=false;this.resumeAt=0;this.editorSelected=false;this.last=0;this.wasMoving=false;this.x=this.row.scrollLeft;
this.addEventListener('pointerover',e=>{if(e.pointerType==='mouse'&&e.target.closest('.ngr-review-flow__card'))this.hovered=true},{signal});
this.addEventListener('pointerout',e=>{if(e.pointerType==='mouse')this.hovered=Boolean(e.relatedTarget?.closest?.('.ngr-review-flow__card'))},{signal});
this.row.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse')this.touching=true},{signal});
const release=e=>{if(e.pointerType!=='mouse'&&this.touching){this.touching=false;this.resumeAt=performance.now()+5000}};
window.addEventListener('pointerup',release,{signal});window.addEventListener('pointercancel',release,{signal});
this.row.addEventListener('wheel',()=>{this.resumeAt=performance.now()+3000},{signal,passive:true});
this.addEventListener('shopify:block:select',()=>{this.editorSelected=true},{signal});
this.addEventListener('shopify:block:deselect',()=>{this.editorSelected=false},{signal});
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting});this.observer.observe(this);
const tick=now=>{
const dt=this.last?Math.min((now-this.last)/1000,.05):0;this.last=now;
const moving=this.visible&&!document.hidden&&!this.media.matches&&!this.hovered&&!this.touching&&!this.editorSelected&&now>=this.resumeAt&&!this.row.querySelector('details[open]')&&!this.row.matches(':focus-visible')&&!this.row.querySelector(':focus-visible');
if(moving&&this.row.scrollWidth>this.row.clientWidth+2&&this.row.children.length>1){
if(!this.wasMoving)this.x=this.row.scrollLeft;
const gap=parseFloat(getComputedStyle(this.row).columnGap)||0;
this.x+=(Number(this.dataset.speed)||18)*dt;
let first=this.row.firstElementChild;let step=first.getBoundingClientRect().width+gap;
while(this.x>=step){this.row.append(first);this.x-=step;first=this.row.firstElementChild;step=first.getBoundingClientRect().width+gap}
this.row.scrollLeft=this.x;
}
this.wasMoving=Boolean(moving);this.frame=requestAnimationFrame(tick);
};
this.frame=requestAnimationFrame(tick);
}
disconnectedCallback(){cancelAnimationFrame(this.frame);this.observer?.disconnect();this.controller?.abort();this.controller=null}
});

  } catch(e) { console.error(e); }
})();
})();
